import api from "./api";

// Interaction response interface
export interface InteractionResponse {
  action: "disliked" | "liked" | "removed" | "unliked";
  dislikes_count: number;
  likes_count: number;
  success: boolean;
}

// Interaction status interface
export interface InteractionStatus {
  dislikes_count: number;
  has_disliked: boolean;
  has_liked: boolean;
  interaction_type: "dislike" | "like" | null;
  likes_count: number;
  success: boolean;
}

export interface NewsArticle {
  author: string;
  category: string;
  created_at: string;
  date: string;
  excerpt: string;
  id: number;
  image: string;
  is_featured: boolean;
  title: string;
  updated_at: string;
}

export interface UpdateItem {
  created_at: string;
  date: string;
  description: string;
  id: number;
  image?: string;
  subtitle: string;
  title: string;
  type: string;
  updated_at: string;
}

// View count response interface
export interface ViewResponse {
  success: boolean;
  views_count: number;
}

export async function fetchFeaturedNews(): Promise<NewsArticle | null> {
  const res = await api.get("/news-articles/featured");
  return res.data;
}

export async function fetchNewsArticles(): Promise<NewsArticle[]> {
  const res = await api.get("/news-articles");
  return res.data;
}

export async function fetchUpdates(): Promise<UpdateItem[]> {
  const res = await api.get("/updates");
  return res.data;
}

// Get interaction status for an update
export async function getInteractionStatus(
  updateId: number,
): Promise<InteractionStatus> {
  const res = await api.get(`/updates/${updateId}/interaction-status`);
  return res.data;
}

// Increment view count
export async function incrementView(updateId: number): Promise<ViewResponse> {
  const res = await api.post(`/updates/${updateId}/view`);
  return res.data;
}

// Toggle dislike for an update
export async function toggleDislike(
  updateId: number,
): Promise<InteractionResponse> {
  const res = await api.post(`/updates/${updateId}/dislike`);
  return res.data;
}

// Toggle like for an update
export async function toggleLike(
  updateId: number,
): Promise<InteractionResponse> {
  const res = await api.post(`/updates/${updateId}/like`);
  return res.data;
}
